/* nx-motion-carousel.js — каруселът с проектите: влачене с мишка с инерция и влизане на картите.
   Собственик: C — интеракции.

   Влачене (само pointer: fine): Draggable мести невидим proxy по x, а ние превеждаме
   отместването в scrollLeft през window.NXAuto.setX — така позицията се върти по модул на
   ширината на кръга и лентата няма край и при влачене, и при инерцията след пускане.
   При натискане самоплъзгането спира; след пускане (или след края на инерцията) му връщаме
   позицията и то тръгва пак след обичайните 1,8 s. Клик по карта след влачене над 6 px се
   поглъща. На тъч устройства не пипаме нищо — родният скрол с инерцията на iOS е по-добър.

   Влизане: картите идват отдясно една след друга, когато каруселът стигне екрана.
   Ако при зареждане лентата вече се вижда (или е над екрана), не скриваме нищо.
   Копията от кръга (.is-clone) тръгват заедно със своя оригинал.
   При prefers-reduced-motion: без влизане и без инерция; влаченето си работи. */
(function () {
  if (window.__nxCar) return;
  window.__nxCar = true;
  if (!window.NX) return;

  var MOVE = 6;   // px — над толкова натискането е влачене, а не клик

  // клик от мишка/пръст след истинско влачене се поглъща; клик от клавиатура (detail 0) — никога
  function blocks(moved, detail) { return moved > MOVE && detail !== 0; }

  function entrance(wrap, track) {
    if (!window.gsap || !window.ScrollTrigger) return null;
    var cards = track.querySelectorAll('.case-card');
    if (!cards.length) return null;
    // вече е на екрана или над него — това, което човек вижда, не го пипаме
    if (wrap.getBoundingClientRect().top < window.innerHeight) return null;

    var n = track.querySelectorAll('.case-card:not(.is-clone)').length || cards.length;
    var tw = null, st = null;
    gsap.set(cards, { x: 60, autoAlpha: 0 });
    function play() {
      if (tw) return;
      if (st) { st.kill(); st = null; }
      tw = gsap.to(cards, {
        x: 0, autoAlpha: 1, duration: 0.9, ease: 'power3.out',
        stagger: function (i) { return (i % n) * 0.06; },   // копието с оригинала си
        clearProps: 'transform,opacity,visibility'
      });
    }
    // onLeave/onEnterBack: ако скролът прескочи цялата лента наведнъж, картите пак се показват
    st = ScrollTrigger.create({ trigger: wrap, start: 'top 88%', onEnter: play, onLeave: play, onEnterBack: play });
    return function () {
      if (st) { st.kill(); st = null; }
      if (tw) tw.kill();
      gsap.set(cards, { clearProps: 'transform,opacity,visibility' });
    };
  }

  function dragger(wrap, flags) {
    var D = window.Draggable;
    if (!D || !window.gsap) return null;
    var I = window.InertiaPlugin;
    gsap.registerPlugin.apply(gsap, I ? [D, I] : [D]);

    var A = window.NXAuto;
    var proxy = document.createElement('div');
    var base = 0, sx = 0, moved = 0, held = false, resetT = 0;

    function to(d) {
      var x = base - (d.x - sx);
      if (A && A.setX) A.setX(wrap, x); else wrap.scrollLeft = x;
    }
    function done() {
      if (!held) return;
      held = false;
      wrap.classList.remove('nx-held');
      if (A && A.resume) A.resume(wrap);
    }
    function onClick(e) {
      if (blocks(moved, e.detail)) { e.preventDefault(); e.stopPropagation(); }
      moved = 0;
    }
    // браузърът иначе хваща линка/снимката и започва свое „drag & drop"
    function noNative(e) { e.preventDefault(); }

    wrap.classList.add('nx-drag');
    wrap.addEventListener('click', onClick, true);
    wrap.addEventListener('dragstart', noNative);

    var d = D.create(proxy, {
      type: 'x',
      trigger: wrap,
      dragClickables: true,      // цялата лента е от линкове
      allowContextMenu: true,    // десен бутон → „Отвори в нов раздел"
      zIndexBoost: false,
      cursor: false,             // курсорите са в CSS на секцията (nx-drag / nx-held)
      inertia: !!(I && flags.motion),
      minDuration: 0.2,
      maxDuration: 1.6,
      onPress: function () {
        clearTimeout(resetT);
        moved = 0;
        held = true;
        wrap.classList.add('nx-held');
        if (A && A.pause) A.pause(wrap);
        base = A && A.getX ? A.getX(wrap) : wrap.scrollLeft;
        sx = this.x;
      },
      onDrag: function () {
        moved = Math.max(moved, Math.abs(this.x - sx));
        if (moved > MOVE) wrap.classList.add('dragging');
        to(this);
      },
      onThrowUpdate: function () { to(this); },
      onRelease: function () {
        wrap.classList.remove('dragging');
        // ако пуснем извън лентата, клик няма да дойде — да не глътнем следващия
        clearTimeout(resetT);
        resetT = setTimeout(function () { moved = 0; }, 0);
        if (!this.isThrowing) done();
      },
      onThrowComplete: done
    })[0];

    return function () {
      clearTimeout(resetT);
      if (d) d.kill();
      wrap.removeEventListener('click', onClick, true);
      wrap.removeEventListener('dragstart', noNative);
      wrap.classList.remove('nx-drag', 'dragging');
      done();
    };
  }

  NX.register('carousel', '.cases-wrap', function (wrap, flags) {
    flags = flags || NX.flags || {};
    var A = window.NXAuto;
    // картите първо се дублират (ако още не са), за да влязат и копията
    if (A && A.ensure) A.ensure(wrap);
    var track = wrap.querySelector('.cases');
    if (!track) return;

    var off = [];
    if (flags.motion) off.push(entrance(wrap, track));
    if (flags.fine) off.push(dragger(wrap, flags));

    return function () { off.forEach(function (f) { if (f) f(); }); };
  });
})();
